import Platforms from 'Components/Platforms/Platforms'

export default Platforms